<template>
  <l-cache :get-data="getRole" :id="$route.query.id" ref="cache">
    <l-layout :layout="['xs12']" bottom-space slot-scope="{data}">
      <v-card>
        <v-card-title style="height: 64px">
          <span class="title pl-2">{{data.name}}</span>
          <v-layout class="pl-4" wrap>
            <v-flex xs6>
              <span class="grey--text caption mr-2">创建时间</span>
              <span class="pr-4">{{$L.time.stringify(data.creationTime) || 'N/A'}}</span>
            </v-flex>
            <v-flex xs6>
              <span class="grey--text caption mr-2">上次更新</span>
              <span class="pr-4">{{$L.time.stringify(data.lastUpdateTime) || 'N/A'}}</span>
            </v-flex>
          </v-layout>
          <v-spacer></v-spacer>
          <v-btn @click="goEdit()" color="primary" flat small>编辑</v-btn>
          <v-btn @click="$refs.cache.retry()" color="primary" flat small>刷新</v-btn>
        </v-card-title>
        <v-card-text>
          <v-container class="py-0" fluid grid-list-md>
            <v-layout wrap class="mb-4">
              <v-flex sm4 xs12>
                <v-text-field
                  disabled
                  label="角色名称"
                  placeholder="N/A"
                  prepend-icon="$vuetify.icons.role"
                  v-model="data.name"
                ></v-text-field>
              </v-flex>
              <v-flex sm8 xs12>
                <v-text-field
                  disabled
                  label="Shiro字段"
                  placeholder="N/A"
                  prepend-icon="$vuetify.icons.shiroStr"
                  v-model="data.shiroStr"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  :rows="1"
                  auto-grow
                  disabled
                  placeholder="N/A"
                  label="角色描述"
                  prepend-icon="$vuetify.icons.description"
                  v-model="data.description"
                ></v-textarea>
              </v-flex>
            </v-layout>
            <v-subheader>绑定权限</v-subheader>
            <v-layout wrap class="mb-4">
              <v-flex xs12>
                <l-data-table
                  :headers="permissionHeaders"
                  :items="data.permissionList"
                  auto-actions
                  flat
                  hide-headers
                  hide-title
                  no-data-text="没有绑定权限"
                ></l-data-table>
              </v-flex>
            </v-layout>
          </v-container>
         <!--// {{data.showGU}}//-->
          <v-expand-transition>
            <v-container class="pt-0" fluid grid-list-md v-if="data.showGU">
              <v-subheader>绑定分组</v-subheader>
              <v-layout class="mb-4" wrap>
                <v-flex xs12>
                  <l-data-table
                    :get-data-func="getBindGroups"
                    :get-data-payload="data"
                    :headers="groupHeaders"
                    auto-actions
                    flat
                    hide-headers
                    hide-title
                    no-data-text="没有绑定分组"
                  ></l-data-table>
                </v-flex>
              </v-layout>
              <v-subheader>绑定用户</v-subheader>
              <v-layout class="mb-4" wrap>
                <v-flex xs12>
                  <l-data-table
                    :get-data-payload="data"
                    :get-data-func="getBindUsers"
                    :headers="userHeaders"
                    auto-actions
                    flat
                    hide-headers
                    hide-title
                    no-data-text="没有绑定用户"
                  ></l-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-expand-transition>
          <v-layout>
            <v-flex class="text-xs-center">
              <v-btn @click="data.showGU = !data.showGU" color="primary" flat>{{data.showGU ? '收起':'显示'}}已绑定用户和分组</v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </l-layout>
  </l-cache>
</template>

<script>
import {time} from '../../../ladmin/utils'

export default {
  name: 'RoleDetails',
  data: () => ({
    // showGU: false,
    groupHeaders: [
      {text: '分组名称', value: 'name', align: 'left', placeholder: 'N/A'},
      {text: '分组描述', value: 'description', align: 'right', placeholder: 'N/A'},
      {text: '上次修改', value: 'lastEditor', align: 'right', placeholder: 'N/A'},
      {text: '创建时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
    ],
    permissionHeaders: [
      {text: '权限名称', value: 'name', align: 'left', placeholder: 'N/A'},
      {text: '权限描述', value: 'description', align: 'right', placeholder: 'N/A'},
      {text: '上次修改', value: 'lastEditor', align: 'right', placeholder: 'N/A'},
      {text: '创建时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
    ],
    userHeaders: [
      {text: '用户姓名', value: 'name', align: 'left', placeholder: 'N/A'},
      {text: '用户账号', value: 'loginId', align: 'right', placeholder: 'N/A'},
      {text: '上次修改', value: 'lastEditor', align: 'right', placeholder: 'N/A'},
      {text: '创建时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
    ],
  }),
  methods: {
    async getRole () {
      let {items} = await this.$store.dispatch('userAdmin/getRoles', {
        pagination: {},
        filter: [{key: 'id', value: this.$route.query.id}]
      })
      if (items && items.length > 0) {
        let role = items[0]
        role.showGU = false
        return role
      }
      else {
        throw Error('未找到该角色')
      }
    },
    getBindGroups (params, role) {
      return this.$store.dispatch('userAdmin/getGroupsByRole', {params, role})
    },
    getBindUsers (params, role) {
      return this.$store.dispatch('userAdmin/getUsersByRole', {params, role})
    },
    goEdit () {
      this.$store.dispatch('L/routerInTab').then(() => {
        this.$router.replace({
          name: 'EditRole',
          params: this.$route.params,
          query: this.$route.query
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
